import {
  ARRIVAL_WORKFLOW_SEARCH_PARAM,
  getArrivalWorkflow,
} from "@replohq/lattice/blocks/workflow-checklist/arrivalWorkflow";
import { generatePath } from "react-router-dom";
import { AGENT_DASHBOARD_ROUTES } from "replo-utils/lib/dashboardRoutes";
import { HOME_WORKFLOW_SEARCH_PARAM } from "schemas/agentIntegration";

/** The workflow a marketing link names. Null is an ordinary sign-up: no link, or a use case with no Home workflow. */
export function getMarketingWorkflow(searchParams: URLSearchParams) {
  return getArrivalWorkflow(searchParams.get(ARRIVAL_WORKFLOW_SEARCH_PARAM));
}

/**
 * The signed prompt a link carries for the chat to start with, as a docs "Try this prompt" link does.
 * A use-case link never counts: older ones carried a brief, and nothing typed on the website reaches the chat.
 */
export function getPromptSeedToken({
  hash,
  searchParams,
}: {
  hash: string;
  searchParams: URLSearchParams;
}) {
  return searchParams.has(ARRIVAL_WORKFLOW_SEARCH_PARAM)
    ? null
    : new URLSearchParams(hash.slice(1)).get("seed");
}

/** Where a marketing link lands an account that already has an Agent project: the Home workflow it names. Null keeps the ordinary landing. */
export function getMarketingWorkflowLandingPath({
  searchParams,
  agentProjectId,
}: {
  searchParams: URLSearchParams;
  agentProjectId: string | null | undefined;
}) {
  const arrival = getMarketingWorkflow(searchParams);
  // An explicit destination wins.
  if (!arrival || !agentProjectId || searchParams.get("next")) {
    return null;
  }
  const homePath = generatePath(AGENT_DASHBOARD_ROUTES.home, {
    projectId: agentProjectId,
  });
  return `${homePath}?${new URLSearchParams({ [HOME_WORKFLOW_SEARCH_PARAM]: arrival.workflow.slug }).toString()}`;
}
